import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { SetupIntentCreateInput, SetupIntentCreatePayload } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = SetupIntentCreateInput;
type TData = SetupIntentCreatePayload;

export const useSetupIntentCreate = (
  options: Omit<UseMutationOptions<TData, TGenericError, TVariables, unknown>, 'mutationFn'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    mutation setupIntentCreate($input: SetupIntentCreateInput!) {
      setupIntentCreate(input: $input) {
        success
        errors
        errorCode

        clientSecret
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    mutationFn: (input: TVariables = {}): Promise<TData> =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      }),
    ...options
  });
};
